// CORE API stripe_account_status: complete, enabled, pending, restricted,incomplete, No account

const STRIPE_STATUS = Object.freeze({
  complete: 'complete',
  enabled: 'enabled',
  pending: 'pending',
  restricted: 'restricted',
  incomplete: 'incomplete',
  noAccount: 'No account',
});

// noinspection JSUnusedGlobalSymbols
export default STRIPE_STATUS;
